import CoveragePopUpWrapper from "./coveragePopUp.style";

import React, { useState, useEffect } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";

import greenTick from "./greenTick.svg";
import whiteArrow from "./white_arrow_right.svg";
import whiteTick from "./whiteTick.svg";
import headerIcon1 from "./headerIcon1.svg";
import globe from "./globe.svg";
import ship from "./ship.svg";
import { withTranslation } from "react-i18next";
import * as globalUtils from "../../../../helpers/utils";
import worldCupIcon from "../../../../assets/images/worldcup_orange.svg";
import { useSelector } from "react-redux";

const CoveragePopUp = (props) => {
  const {
    show = false,
    t,
    onPopupClose = () => false,
    schengen = true,
    gcc = true,
    worldwide = true,
    worldcup = false,
  } = props;
  const [displayResponsive, setDisplayResponsive] = useState(show);
  const [fileDownloader, setFileDownloader] = useState(false);
  const showRTL = globalUtils.isArabic(props.i18n.language);

  useEffect(() => setDisplayResponsive(show), [show]);
  const { businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === globalUtils.BUSINESS_LINE_PATHS.STC)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.STC;

  const onPopupHide = () => {
    setDisplayResponsive(false);
    onPopupClose();
  };
  const gccList = [
    t("cancellation"),
    t("curtailment"),
    t("missed-departure"),
    t("personal-accident"),
    t("emergency-medical-expenses"),
    t("medical-inconvenience-benefit"),
    t("personal-property"),
    t("delayed-baggage"),
    t("personal-public-liability"),
  ];
  const schengenList = [
    t("personal-accident"),
    t("emergency-medical-expenses-limited"),
  ];

  const worldwideList = [
    t("worldcup.homeInsurance"),
    t("cancellation"),
    t("curtailment"),
    t("missed-departure"),
    t("personal-accident"),
    t("emergency-medical-expenses"),
    t("medical-inconvenience-benefit"),
    t("personal-property"),
    t("delayed-baggage"),
    t("personal-public-liability"),
  ];

  const worldcupList = [
    t("worldcup.cancellation"),
    t("worldcup.curtailment"),
    t("worldcup.missed_departure"),
    t("worldcup.personal_accident"),
    t("worldcup.emergency_med_exp"),
    t("worldcup.med_incon_benifit"),
    t("worldcup.personal_prpty"),
    t("worldcup.delayed_baggage"),
    t("worldcup.personal_public_liability"),
    t("worldcup.covid_19"),
  ];

  const onClickHandleDownload = () => {
    setFileDownloader(true);
    fetch("Travel_Qatar-Full_Policy_Wordings.pdf")
      .then((response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "Travel_Qatar-Full_Policy_Wordings.pdf";
          alink.click();
        });
      })
      .finally(() => setFileDownloader(false));
  };

  return (
    <Dialog
      visible={displayResponsive}
      onHide={onPopupClose}
      breakpoints={{ "960px": "75vw" }}
      // style={worldcup ? { width: "40%" } : { width: "50%" }}
      showHeader={false}
      closable={false}
      className="overflow-hidden"
      contentClassName="p-0"
      modal={true}
      style={{ color: businessColor }}
    >
      <CoveragePopUpWrapper>
        <div className={`p-4 ${worldcup ? "worldcup_bg_img" : ""}`}>
          <div className="row">
            {schengen && (
              <div className="col-sm-12">
                <img
                  className="headerIcon1"
                  src={headerIcon1}
                  alt="Schengen icon"
                />
                <h2
                  className={
                    businessLine ? `headerTitle-${businessLine}` : "headerTitle"
                  }
                >
                  {t("schengen")}
                </h2>
                <ul className={showRTL ? "listContent-rtl" : "listContent"}>
                  {schengenList.map((item) => (
                    <li key={`list-${item}`} className="primaryListItem">
                      <img
                        className={showRTL ? "iconStyle-rtl" : "iconStyle"}
                        src={greenTick}
                        alt="list icon"
                      />{" "}
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {gcc && (
              <div className="col-sm-12">
                <img className="headerIcon2" src={ship} alt="GCC icon" />
                <h2
                  className={
                    businessLine ? `headerTitle-${businessLine}` : "headerTitle"
                  }
                >
                  {t("gcc")}
                </h2>
                <ul className={showRTL ? "listContent-rtl" : "listContent"}>
                  {gccList.map((item, index) => (
                    <li key={`list-${index}`} className="primaryListItem">
                      <img
                        className={showRTL ? "iconStyle-rtl" : "iconStyle"}
                        src={greenTick}
                        alt="list icon"
                      />{" "}
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {worldwide && (
              <div className="col-sm-12">
                <img className="headerIcon3" src={globe} alt="Worldwide icon" />
                <h2
                  className={
                    businessLine ? `headerTitle-${businessLine}` : "headerTitle"
                  }
                >
                  {t("worldwidePlus2")}
                </h2>
                <ul className={showRTL ? "listContent-rtl" : "listContent"}>
                  {worldwideList.map((item, index) => (
                    <li key={`list-${index}`} className="primaryListItem">
                      <img
                        className={showRTL ? "iconStyle-rtl" : "iconStyle"}
                        src={greenTick}
                        alt="list icon"
                      />{" "}
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {worldcup && (
              <div className="col-md-12 col-sm-12 worldcup_coverage">
                <div className="worldcup_coverage_header">
                  <img
                    className="headerIcon1"
                    src={worldCupIcon}
                    alt="wordlcup icon"
                  />
                  <div>
                    <h2
                      className={
                        businessLine
                          ? `headerTitle-${businessLine}`
                          : "headerTitle"
                      }
                    >
                      {t("worldcup.worldcup")}
                    </h2>
                    <p className="headerSubtitle">{t("worldcup.date")}</p>
                  </div>
                </div>
                <ul className={showRTL ? "listContent-rtl" : "listContent"}>
                  {worldcupList.map((item) => (
                    <li key={`list-${item}`} className="primaryListItem">
                      <img
                        className={showRTL ? "iconStyle-rtl" : "iconStyle"}
                        src={whiteTick}
                        alt="list icon"
                      />{" "}
                      {item}
                    </li>
                  ))}
                </ul>
                <p
                  className={
                    `terms_condition_txt ${
                      showRTL ? "terms_condition_txt_rtl" : ""
                    }` + (businessLine ? " terms_condition_txt-stc" : "")
                  }
                >
                  {t("worldcup.t_n_c")}
                </p>
                <hr />
                <div
                  className="worldcup_coverage_more_info"
                  onClick={onClickHandleDownload}
                >
                  {fileDownloader ? (
                    <ProgressSpinner />
                  ) : (
                    <>
                      <span>{t("worldcup.for_more_info")}</span>
                      <img src={whiteArrow} alt="arrow" />
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="col-12 text-center">
              <Button
                onClick={() => onPopupHide()}
                icon="pi pi-times-circle"
                iconPos="right"
                label={t("close")}
                style={{ backgroundColor: businessColor }}
              />
            </div>
          </div>
        </div>
      </CoveragePopUpWrapper>
    </Dialog>
  );
};

export default withTranslation()(CoveragePopUp);
